export enum ResponseCode {
    UserAlreadyAdmin = "UserAlreadyAdmin",
    SystemInternalError = "SystemInternalError",
    InvalidRequestFormat = "InvalidRequestFormat",
    UserNotFound = "UserNotFound",
    OtpExpired = "OtpExpired",
    InvalidDataOrArgument = "InvalidDataOrArgument",
    AuthenticationError = "AuthenticationError",
    AuthorizationError = "AuthorizationError",
    EmailCouldNotSent = "EmailCouldNotSent",
    DuplicateOtp = "DuplicateOtp",
    MediaTypeNotSupported = "MediaTypeNotSupported",
    SurveyLinkedToVideo = "SurveyLinkedToVideo",
    IncorrectOptionRecruitmentFail = "IncorrectOptionRecruitmentFail",  
    StudyAlreadyCompleted = "StudyAlreadyCompleted",
    Ok = "Ok",
    TesterEmotionNotFound = "TesterEmotionNotFound",
    RecordAlreadyExists = "RecordAlreadyExists",
    TesterNotFound = "TesterNotFound",
    MediaFileUseInStudy = "MediaFileUseInStudy",
    BusinessMailRequired = "BusinessMailRequired",
    ProjectNotFound = 'ProjectNotFound',
    StimuliNotFound = "StimuliNotFound",
    FileNotFound = "FileNotFound",
    InvalidFileType = "InvalidFileType",
    UserAlreadyPresent = "UserAlreadyPresent",
    ParticipantEmotionNotFound = "ParticipantEmotionNotFound",
    MeetingIsScheduledForFutureTime = "MeetingIsScheduledForFutureTime",
    Completed = "Completed",
    StimuliRunning = "StimuliRunning",
    MeetingRunning = "MeetingRunning",
    QuestionProcessing = "QuestionProcessing",
    MeetingNotFound = "MeetingNotFound",
    MeetingCompletedOrRunning = "MeetingCompletedOrRunning",
    DuplicateAnnotation = "DuplicateAnnotation",
    TopicDeletionFailed = "TopicDeletionFailed",
    MeetingElapsed = "MeetingElapsed",
    OperationNotAllowed = "OperationNotAllowed",
    SubscriptionExpireThresholdBreach = "SubscriptionExpireThresholdBreach",
    SubscriptionExpired = "SubscriptionExpired",
    RecordNotFound = "RecordNotFound",
    TermAndConditionNotAccepted = "TermAndConditionNotAccepted",
    TranscriptionNotAvailable = "TranscriptionNotAvailable",
    MinimumTranscriptionRequired = "MinimumTranscriptionRequired",
    AlreadyInProgress = "AlreadyInProgress",
    MaxLimitExceeded = "MaxLimitExceeded",
    ProjectIsNotPublished = "ProjectIsNotPublished",
    FailedToDeleteEmbedding = "FailedToDeleteEmbedding",
    FileIsEmbeddingQueued = "FileIsEmbeddingQueued",
    FileNotEmbedded = "FileNotEmbedded",
    CurrentlyUnableToProcess = "CurrentlyUnableToProcess",
    UnsafePromptDetected = "UnsafePromptDetected",
    ProjectPptCreationLimitExceeded = "ProjectPptCreationLimitExceeded",
    OrgPptCreationLimitExceeded = "OrgPptCreationLimitExceeded",
    StimuliUploadMaxLimitExceeded = "StimuliUploadMaxLimitExceeded",
    ProjectCreationLimitExceeded = "ProjectCreationLimitExceeded",
    StimuliProcessingMaxLimitExceeded = "StimuliProcessingMaxLimitExceeded",
    InvalidStatus = "InvalidStatus",
    PptFileUnderCreation = "PptFileUnderCreation",
    FileInProcessingCannotBeDeleted = "FileInProcessingCannotBeDeleted"
}